import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc64 = {
    title: "Image 64: Example of IT infrastructure for e-filing at High Court of Karnataka, Bangalore.",
    para1: <>
        <p>This is an image of the counter of the e-Seva Kendra from the inside. The counter has many computer systems on it with chairs in front of it. </p>
        <p>The outside of the Court Complex can be seen beyond the counter. Many vehicles are parked outside. </p>
    </>,
}

export const ImageDesc65 = {
    title: "Image 65: Example of dedicated video-conferencing cabins at the e-Seva Kendra established in Shivamogga District Court, Karnataka.",
    para1: "The image shows a video-conferencing cabin of the e-Seva Kendra at Shivamogga District Court.  The cabin is made of a temporary partition material. It has a red board on top of it with a sign written in Kannada and English that says “Video Conference Cabin” and E-Sewa Kendra/Help Desk”. The cabin has several marigold garlands decorating it which indicates that the picture has been taken at the time of the inauguration. "
}

export const FigureDesc58 = {
    title: "Figure 58: Typical floor plan for the e-Seva Kendra.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure depicts a floor plan for the e-Seva Kendra, which has a total measurement of 6625 mm x 14370 mm. The entrance to the e-Seva Kendra is provided at the top-left of the layout. The door leads from the main building entrance for advocates, litigants, and Court staff described in Figure 25 into the e-Seva Kendra.
        </p>
        <p>
            The features are described in a clockwise manner.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "At the left of the floor plan, the entrance lobby in the main building entrance for advocates, litigants, and Court staff is shown. This area has provisions for four accessible information kiosks next to each other, and drinking water facilities.",
                    "At the top-left of the floor plan, an entrance door is provided into the e-Seva Kendra.",
                    <>
                        In front of the entrance door, along the opposing wall of the e-Seva Kendra, two separate video-conferencing cabins (each measuring 2300 mm x 2150 mm) are provided.
                        {getCircleTypeListItem([
                            "Each of the video-conferencing cabins has an entrance at the left, and a desk and chair to conduct video-conferencing. The cabin is equipped with digital technology."
                        ])}
                    </>,
                    <>
                        Next to the video-conferencing cabins and along the right side of the e-Seva Kendra, three counters manned by staff are provided.
                        {getCircleTypeListItem([
                            "Counter 1 is an accessible counter.",
                            "All three counters are equipped with a desk and a chair for the staff, and with the necessary digital technology, including computer systems.",
                            "The counters have a small partition through which the staff can interact with the visitors.",
                            "Storage is provided at the back of the desk and chairs used by the staff.",
                            "Counter 3 has a door towards the back, through which the staff may enter/exit the enclosed seating area behind the counters from the rest of the eSeva Kendra.",

                        ])}
                    </>,

                    "Next to the three counters and at the bottom-right corner of the layout, a door is provided which leads towards other Administrative Offices, and which may be used by the eSeva Kendra.",
                    "Drinking water provisions are provided opposite this door, and at the bottom-left corner of the eSeva Kendra.",
                    "Green plants are provided next to the drinking water provisions.",
                    "Next to the drinking water provisions and green plants, and along the left-side wall of the eSeva Kendra leading up to the main entrance at the top-left, seating is provided in 3 sets of 5 chairs each. This includes wheelchair-accessible seating at the end of the seating.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc59 = {
    title: "Figure 59: Representation of the e-Seva Kendra.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure depicts a 3D render of the plan for the e-Seva Kendra. The key for the render is provided at the bottom right of the figure. The entrance to the e-Seva Kendra from the Court Complex/building is provided at the bottom-right of the figure.
        </p>
        <p>The features of the space are described in a clockwise manner. </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "To the right of the figure, the lobby/public entrance from the Court Complex/building is shown, with six information kiosks. ",
                    "At the bottom-right, an entrance is provided from the Court Complex/building into the eSeva Kendra.",
                    <>
                        In front of the entrance door, along the opposing wall, two separate video-conferencing rooms are provided.
                        {getCircleTypeListItem([
                            "These rooms are equipped with a desk and chair and with the necessary digital technology. ",
                            "A separate entrance into these enclosed rooms is provided at the left of each room. "
                        ])}
                    </>,
                    <>
                        Next to the two video-conferencing rooms and along the left of the figure, three counters manned by staff are provided.
                        {getCircleTypeListItem([
                            "Counter 1 is a wheelchair-accessible counter.",
                            "Storage is provided at the back of the desk and chairs used by the staff.",
                            "Counter 3 has a door towards the back, through which the staff may enter/exit the enclosed seating area behind the counters from the rest of the eSeva Kendra.",

                        ])}
                    </>,
                    "At the top-left of the figure, a door is provided which leads towards other Administrative Offices.",
                    "Windows are provided along the wall in between this door and the wall opposing the door.",
                    "Directly opposite the door and at the top-right of the figure, drinking water provisions are situated. ",
                    "Seating is provided along the right-side wall next to the drinking water provision, and opposite the counters. This includes provision for wheelchair-accessible seating.",
                ])}
            </div>
        </p>
    </>
}



